export default {
	1: { homeUrl: 'https://www.valueplusonline.com', name: 'Value Plus' },
	2: { homeUrl: 'https://www.myfunsource.com', name: 'FunSource' },
	3: { homeUrl: 'https://www.mypulseonline.com', name: 'Pulse' },
	9: { homeUrl: 'https://www.essentialsforhome.com', name: 'Essentials for Home' },
	15: { homeUrl: 'https://www.homeplayonline.com', name: 'HomePlay' },
	17: { homeUrl: 'https://www.myvalueaccess.com', name: 'Value Access' },
	57: { homeUrl: 'https://saverssolution.onlinemembershipservices.com', name: 'Savers Solution' },
	71: { homeUrl: 'https://valuesourceonline.onlinemembershipservices.com', name: 'Value Source' },
	75: { homeUrl: 'https://www.mybudgetsource.com', name: 'Budget Source' },
	79: { homeUrl: 'https://www.tasteforsavings.com', name: 'Taste for Savings' },
	143: { homeUrl: 'https://mybuyersplus.onlinemembershipservices.com', name: 'Buyers Plus' },
	147: { homeUrl: 'https://www.isavingscentral.com', name: 'Savings Central' },
	282: { homeUrl: 'https://www.mygiftcardconnection.com', name: 'Gift Card Connection' },
	308: { homeUrl: 'https://www.rizzbates.com', name: 'Rizzbates' }
};
